export default (text) => (text ? text.replace(/\n/gi, '<br>') : text);
